// BODY NAV PADding Top + Footer PADding Bottom (Fixed footer)
//

var body_nav_pad = function () {

  var body = $('body');

  function headerH() {
    //
    var headerHeight = $('.header').outerHeight();
    $(body).css('padding-top',(parseInt(headerHeight) / 16)+'rem');
  }
  // function footerH() {
  //   //
  //   var footerHeight = $('.footer__wrapper').outerHeight();
  //   $(body).css('padding-bottom',(parseInt(footerHeight) / 10)+'rem');
  // }


  window.addEventListener('load', function(event) {
    headerH();
    // footerH();
  });


  var resizeTimer;
  $(window).on('resize orientationchange', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Run code here, resizing has "stopped"
      headerH();
      // footerH();
    }, 380);

  });

// //
}
